/**
 * Colors no hex can stand for. A copy of the backend's `AttributeValueSpecialColor`, which the API
 * spec does not carry: the field itself is a plain string.
 */
enum SpecialColor {
  Transparent = 'transparent',
  Multicolor = 'multicolor',
}

const HEX_COLOR_PATTERN = /^#[0-9a-f]{6}$/;

/**
 * The CSS `background` for a filter value's color, or `null` for one this build does not understand,
 * which is then left without a swatch rather than drawn wrong.
 *
 * A two-tone color (`#aaaaaa,#bbbbbb`) is split on the diagonal with a hard edge, the way stores draw
 * a "black/white" item: blended into a gradient it would read as a third color in between.
 */
export function buildColorSwatchBackground(color: string | null | undefined): string | null {
  switch (color) {
    case SpecialColor.Transparent:
      return 'repeating-conic-gradient(#d4d4d4 0 25%, #ffffff 0 50%) 50% / 6px 6px';
    case SpecialColor.Multicolor:
      return 'conic-gradient(#f44336, #ffeb3b, #4caf50, #00bcd4, #3f51b5, #e91e63, #f44336)';
  }

  const hexes = (color ?? '').split(',');
  if (hexes.length > 2 || !hexes.every(hex => HEX_COLOR_PATTERN.test(hex))) {
    return null;
  }

  return hexes.length === 2 ? `linear-gradient(135deg, ${hexes[0]} 50%, ${hexes[1]} 50%)` : hexes[0];
}
